/**
 * Common functionality for managing the notes embedded within a model
 */

import _ from 'lodash'

import Notes from './notes'

function NoteManager(model) {
	this.model = model
	this.model.on('change:notes', function() {
		this._notes = null
	}.bind(this))
}

_.extend(NoteManager.prototype, {

	// returns a Backbone.Collection of the notes
	notes: function() {
		if (!this._notes) {
			this._notes = new Notes(this.model.get('notes'), { section: this.model.section })
		}
		return this._notes
	},

	// retrieves a Note model based on the given noteId
	note: function(noteId) {
		return this.notes().get(noteId)
	},

	// add or update the given note within the model
	setNote: function(note) {
		this.notes().add(note, { merge: true })
		this.model.set('notes', this._notes.toJSON())
	},

	deleteNote: function(note) {
		this.notes().remove(note)
		this.model.set('notes', this._notes.toJSON())
	}

})

export default NoteManager

NoteManager.__filename__ = 'notes/note-manager.js'
